import { render, staticRenderFns } from "./ReassignOwnershipPage.vue?vue&type=template&id=5da231fe"
import script from "./ReassignOwnershipPage.vue?vue&type=script&lang=js"
export * from "./ReassignOwnershipPage.vue?vue&type=script&lang=js"
import style0 from "./ReassignOwnershipPage.vue?vue&type=style&index=0&id=5da231fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports